// Single entry point for environment variables.
// Each access uses the literal `import.meta.env.VITE_*` form so that Vite's
// define plugin can statically replace it at build time (including minified
// bundles). Destructuring / dynamic keys on `import.meta.env` would defeat
// the replacer and crash in production where `import.meta.env` isn't a real
// object at runtime.

export const PRICEMOOV_VERSION = import.meta.env.VITE_PRICEMOOV_VERSION;
export const BASE_BACKEND_URL = import.meta.env.VITE_BASE_BACKEND_URL;
export const GRAPHQL_BASE_BACKEND_URL = import.meta.env.VITE_GRAPHQL_BASE_BACKEND_URL;
export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;
export const BEAMER_ID = import.meta.env.VITE_BEAMER_ID;
export const APP_ENV = import.meta.env.VITE_APP_ENV;
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;
export const SSO_CONNECTION = import.meta.env.VITE_SSO_CONNECTION;
export const DEBUG = import.meta.env.VITE_DEBUG;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export const IS_DEV = import.meta.env.DEV;
export const IS_TEST = import.meta.env.MODE === 'test';
export const IS_PROD = import.meta.env.PROD;

// Opt-in: set `VITE_ENABLE_DEV_MSW=true` in `.env.local` to start MSW's
// service worker for dev-time API mocking (see `src/redesign/mocks/dev/`).
// Off by default because an empty handler list + same-origin pass-through
// breaks SPA navigations (React error #130-style "Failed to convert value
// to 'Response'"). Ignored outside dev mode.
export const ENABLE_DEV_MSW = import.meta.env.VITE_ENABLE_DEV_MSW === 'true';
